import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import DashboardTable from "./DashboardTable";
import "./Dashboard.css";
import SearchInput from "../../UIComponents/SearchInput/SearchInput";
import {
  dashboardStyleList,
  dashboardStyleListSearch,
  expandAccordion,
  reportGeneration,
  resetDashboardData,
  resetDashboardSearch,
  dashboardStyleSeason
} from "../../Redux/actions/Dashboard/Dashboard";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "../../UIComponents/Toast";
import { SyncOutlined } from "@ant-design/icons";
import { Modal, Button } from "antd";
import DropDown from "../../UIComponents/DropDown/DropDown";
import { srfStyleList } from "../../Redux/actions/Srf/Srf";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromUrl = searchParams.get("page");
  const pageSizeFromUrl = searchParams.get("pageSize");
  const seasonData = useSelector((state) => state?.Srf?.srfFilterData);
  const dashboardDataLoader = useSelector(
    (state) => state?.Dashboard?.listLoader
  );
  const [searchresult, setSearchresult] = useState("");
  const [filterresult, setFilterresult] = useState();
  const [isReportGenerated, setIsReportGenerated] = useState(false);
  const [isExported, setIsExported] = useState(false);
  const [seasonOptions, setSeasonOptions] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [allSeasonsList, setAllSeasonsList] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [brandOptions, setBrandOptions] = useState([]);
  const [brandId, setBrandId] = useState();
  const [brand, setBrand] = useState();
  const [statusOption, setStatusOptions] = useState();
  const [status, setStatus] = useState();
  const option = [
    // {
    //   value: "All",
    //   label: "All",
    // },
    {
      value: "Aims",
      label: "Aims",
    },
    {
      value: "Ayesha",
      label: "Ayesha",
    },
    {
      value: "Beacon",
      label: "Beacon",
    },
    {
      value: "Bonroy",
      label: "Bonroy",
    },
    {
      value: "Crescent pk",
      label: "Crescent pk",
    },
    {
      value: "Denoho",
      label: "Denoho",
    },
    {
      value: "Dynamic",
      label: "Dynamic",
    },
    {
      value: "Enva",
      label: "Enva",
    },
    {
      value: "Evergreen",
      label: "Evergreen",
    },
    {
      value: "Everight",
      label: "Everight",
    },
    {
      value: "Four seasons",
      label: "Four seasons",
    },
    {
      value: "Ideal",
      label: "Ideal",
    },
    {
      value: "Infiiloom",
      label: "Infiiloom",
    },
    {
      value: "Interloop",
      label: "Interloop",
    },
    {
      value: "Kahatex",
      label: "Kahatex",
    },
    {
      value: "Kamal",
      label: "Kamal",
    },
    {
      value: "Keystone",
      label: "Keystone",
    },
    {
      value: "MSL",
      label: "MSL",
    },
    {
      value: "Northeast",
      label: "Northeast",
    },
    {
      value: "Ou wei",
      label: "Ou wei",
    },
    {
      value: "Premium",
      label: "Premium",
    },
    {
      value: "Rong xing",
      label: "Rong xing",
    },
    {
      value: "Royal",
      label: "Royal",
    },
    {
      value: "Royce",
      label: "Royce",
    },
    {
      value: "RRK",
      label: "RRK",
    },
    {
      value: "Salus",
      label: "Salus",
    },
    {
      value: "Slane",
      label: "Slane",
    },
    {
      value: "Spry",
      label: "Spry",
    },
    {
      value: "Super",
      label: "Super",
    },
    {
      value: "Talent",
      label: "Talent",
    },
    {
      value: "Talent Cambodia",
      label: "Talent Cambodia",
    },
    {
      value: "Tauseef",
      label: "Tauseef",
    },
    {
      value: "Textilfort",
      label: "Textilfort",
    },
    {
      value: "Walt",
      label: "Walt",
    },
    {
      value: "Xuren",
      label: "Xuren",
    },
    {
      value: "Yiheng",
      label: "Yiheng",
    },
    {
      value: "Shahzad Textile",
      label: "Shahzad Textile",
    },
    {
      value: "Close Knit",
      label: "Close Knit",
    },
    {
      value: "Superhouse",
      label: "Superhouse",
    },
    {
      value: "Mustaqim",
      label: "Mustaqim",
    }
  ];
  const sortedOptions = [...option].sort((a, b) =>
    a.label.localeCompare(b.label)
  );
  const TOTAL_PER_PAGE = 100;
  const CHUNK_SIZE = 25;
  const [currentPage, setCurrentPage] = useState(
    pageFromUrl ? parseInt(pageFromUrl) : 1
  );
  const [pageSize, setPageSize] = useState(
    pageSizeFromUrl ? parseInt(pageSizeFromUrl) : TOTAL_PER_PAGE
  );

  useEffect(() => {
    const searchParam = searchParams.get("search");
    // const seasonParam = searchParams.get("season");
    const seasonParam = searchParams.get("searchfilter");
    const pageParam = searchParams.get("page");
    const pageSizeParam = TOTAL_PER_PAGE;

    setSearchresult(searchParam || "");
    setSearchInput(searchParam || "");
    let parsedSeason = [];
    if (seasonParam) {
      try {
        parsedSeason = JSON.parse(seasonParam);
      } catch (e) {
        parsedSeason = [seasonParam]; // fallback for old format
      }
    }
    setFilterresult(parsedSeason);
    // setFilterresult(seasonParam || undefined);
    setCurrentPage(pageParam ? parseInt(pageParam) : 1);
    setPageSize(TOTAL_PER_PAGE);

    // if (searchParam || seasonParam) {
    //   dispatch(
    //     dashboardStyleListSearch(
    //       searchParam,
    //       // seasonParam || "",
    //       parsedSeason,
    //       pageSizeParam || 10,
    //       pageParam || 1
    //     )
    //   );
    // } else {
    //   dispatch(dashboardStyleList(pageParam || 1, pageSizeParam || 10));
    // }
  }, [searchParams]);

  useEffect(() => {
    dispatch(srfStyleList("", ""));
  }, []);

  useEffect(() => {
    if (Array.isArray(seasonData)) {

      const seasons = [
        ...new Set(
          seasonData
            .map((item) => item?.season?.trim().toUpperCase())
            .filter(Boolean)
        ),
      ];

      setAllSeasonsList(seasons);

      const formattedSeasons = [
        { value: "ALL", label: "Select All" },
        ...seasons.map((season) => ({ value: season, label: season })),
      ];
      setSeasonOptions(formattedSeasons);

      // Process brands (corrected syntax)
      const uniqueBrands = [
        ...new Set(
          seasonData
            .map((item) => item?.brand?.trim())
            .filter(Boolean)
        ),
      ];

      const formattedBrands = [
        ...uniqueBrands.map((brand) => ({
          value: brand,
          label: brand,
        })),
      ];
      console.log("formaated", formattedBrands)
      setBrandOptions(formattedBrands);

      const uniqueStatus = [
        ...new Set(
          seasonData
            .map((item) => item?.status?.trim())
            .filter(Boolean)
        ),
      ];

      const formattedStatus = [
        ...uniqueStatus.map((status) => ({
          value: status,
          label: status,
        })),
      ];
      setStatusOptions(formattedStatus);
    }
  }, [seasonData]);

  // Watch page, pageSize, search, and filter changes
  console.log("sortedOptions", sortedOptions)
  useEffect(() => {
    if (searchresult?.trim() || filterresult?.length || brand || brandId || status) {
      dispatch(
        dashboardStyleListSearch(
          searchresult || [],
          filterresult || [],
          brand || "",
          brandId || "",
          status || "",
          // pageSize,
          TOTAL_PER_PAGE,
          currentPage
        )
      );
    } else {
      dispatch(dashboardStyleList(currentPage, TOTAL_PER_PAGE));
    }
  }, [currentPage, TOTAL_PER_PAGE, filterresult, searchresult, brand, brandId, status]);


  const updateQueryParams = (params) => {
    const newParams = new URLSearchParams(searchParams);

    if (params.search !== undefined) {
      if (params.search !== "") {
        newParams.set("search", params.search);
      } else {
        newParams.delete("search");
      }
    }
    if (Array.isArray(params.season)) {
      if (params.season.length) {
        newParams.set("searchfilter", JSON.stringify(params.season));
      } else {
        newParams.delete("searchfilter");
      }
    }
    if (params.page !== undefined) {
      newParams.set("page", params.page);
    }
    if (params.pageSize !== undefined) {
      newParams.set("pageSize", params.pageSize);
    }
    setSearchParams(newParams);
  };

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    // only when cleared
    if (!value.trim()) {
      setSearchresult("");
      setFilterresult([]);
      setCurrentPage(1);

      updateQueryParams({
        search: "",
        season: [],
        page: 1,
        TOTAL_PER_PAGE
      });

      dispatch(resetDashboardSearch());
      dispatch(resetDashboardData());
      return;
    }
      setSearchresult(value);

  updateQueryParams({
    search: value,
    season: filterresult || [],
    page: 1,
    TOTAL_PER_PAGE,
  });

  dispatch(expandAccordion(null));
  };

  const onSearchEnter = (event) => {
    if (event.key === "Enter") {
      const value = event.target.value.trim();

      if (!value && !filterresult?.length) {
        toast.error("Please enter a value");
        return;
      }

      setSearchresult(value);

      updateQueryParams({
        search: value,
        season: filterresult || [],
        page: 1,
        TOTAL_PER_PAGE,
      });

      dispatch(expandAccordion(null));
      // dispatch(resetDashboardData());
    }
  };



  const onSeasonChange = (values) => {
    const finalValues = Array.isArray(values) ? values : [];
    let updatedValues;

    if (finalValues.includes("ALL")) {
      updatedValues = allSeasonsList;
    } else if (finalValues.length === allSeasonsList.length) {
      updatedValues = allSeasonsList;
    } else {
      updatedValues = finalValues;
    }
    setFilterresult(updatedValues);
    updateQueryParams({
      search: searchresult,
      season: updatedValues,
      page: 1,
      TOTAL_PER_PAGE,
    });

    // setCurrentPage(1);
  };
  const handleChange = (value) => {
    setBrandId(value);
  };

  const handleBrandChange = (value) => {
    setBrand(value);
  };
  const handleStatusChange = (value) => {
    setStatus(value);
  };

  const onRefresh = () => {
    setSearchresult("");
    setFilterresult([]);
    setSearchInput("");
    setSelectedRows([]);
    setCurrentPage(1);
    setPageSize(TOTAL_PER_PAGE);
    setSearchParams({});
    setBrand()
    setBrandId()
    setStatus()
    dispatch(dashboardStyleList(1, TOTAL_PER_PAGE));
    dispatch(resetDashboardSearch());
    dispatch(expandAccordion(null));
    dispatch(resetDashboardData());
  };

  const reportGenerate = () => {
    setIsReportGenerated(true);
  };

  const reportExport = () => {
    if (!selectedRows.length) {
      toast.error("Please select at least one row to export.");
      return;
    }

    const styleSeasonArray = selectedRows
      .map((row) => row.style_season)
      .filter(Boolean);

    if (!styleSeasonArray.length) {
      toast.error("No valid style_season values to export.");
      return;
    }

    dispatch(dashboardStyleSeason(styleSeasonArray));
  };

  const onContinue = () => {
    setIsReportGenerated(false);
    dispatch(reportGeneration());
  };

  const handleCancel = () => {
    setIsReportGenerated(false);
  };


  return (
    <div>
      <div className="dashboard-wrapper">
        <div className="dashboard-input-dropdown">

          <SearchInput
            // value={searchresult}
            value={searchInput}
            onKeyPress={onSearchEnter}
            onChange={onSearchChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^a-zA-Z0-9," ]/g, "");
            }}
            className="dashboard-search-input"
            placeholder="Search by Parent Style, Brand, Collection, WO, Status"
          />

          <DropDown
            className="season-dropdown"
            mode="multiple"
            allowClear
            onChange={onSeasonChange}
            placeholder={"Season"}
            option={seasonOptions}
            value={filterresult}
            enableSelectAll
          />

          <DropDown
            allowClear
            placeholder={"Brand"}
            option={brandOptions}
            // options={brands}
            value={brand}
            onChange={handleBrandChange}
          />
          <DropDown
            allowClear
            placeholder={"Vendor"}
            option={sortedOptions}
            value={brandId}
            onChange={handleChange}
          />
          <DropDown
            allowClear
            placeholder={"Status"}
            option={statusOption}
            value={status}
            onChange={handleStatusChange}
          />
          <div className="dashboard-sync-icon">
            <SyncOutlined spin={dashboardDataLoader} onClick={onRefresh} />
          </div>
          <Button onClick={reportGenerate} className="dashboard-button">
            Generate Report
          </Button>
          <Button onClick={reportExport} className="dashboard-button">
            Export
          </Button>
        </div>

        <DashboardTable
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          updateQueryParams={updateQueryParams}
          selectedRows={selectedRows}
          onSelectionChange={setSelectedRows}
          loading={dashboardDataLoader}
          searchTerm={searchresult}
          seasonFilter={filterresult}
          brand={brand}
          brandId={brandId}
          status={status}
          Total={TOTAL_PER_PAGE}
          ChunkSize={CHUNK_SIZE}
        />
      </div>
      <Modal
        title="The report generation might take up to 5 minutes, you want to continue?"
        open={isReportGenerated}
        okText={"save"}
        footer={null}
        onCancel={handleCancel}
      >
        <div className="dashboard-modal-buttons">
          <Button className="modal-yes-button" onClick={onContinue}>
            Yes
          </Button>
          <Button className="modal-cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Dashboard;